import { m } from 'motion/react';

const AnimatedSection = ({
  children,
  id,
  className,
  containerVariants = {
    hidden: {},
    visible: {
      transition: { staggerChildren: 0.3 },
    },
  },
  ...props
}) => {
  return (
    <m.section
      id={id}
      className={className}
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      {...props}
    >
      {children}
    </m.section>
  );
};

export default AnimatedSection;
